module.exports = __webpack_public_path__ + "static/javascript-definitive-guide-0185e475ba8ea112c1b726790a1aca8b.jpeg";